import { Dashboards, InboxView, ChartsView, SearchView, TaskView, ElementsView, CardsView, FormsView, TablesView, Timeline, TimelineGallery, Illustrations, Typography, Pricing, Faq, Icons, Error500, NotFound } from './views';

const routes = [
  { path: "/", name: "Home", component: Dashboards['Dashboard'] },
  { path: "/layout", name: "Layout", component: Dashboards['Dashboard'], meta: {layout: 'layout'} },
  { path: "/layout1", name: "Layout 1", component: Dashboards['Dashboard1'], meta: {layout: 'layout1'} },
  { path: "/home", name: "Dashboard 1", component: Dashboards['Dashboard'] },
  { path: "/home1", name: "Dashboard 2", component: Dashboards['Dashboard1'] },
  { path: "/home2", name: "Dashboard 3", component: Dashboards['Dashboard2'] },
  { path: "/home3", name: "Dashboard 4", component: Dashboards['Dashboard3'] },
  { path: "/home4", name: "Dashboard 5", component: Dashboards['Dashboard4'] },
  { path: "/charts", name: "Charts", component: ChartsView, showInNav: true, icon:"icon-chart icons mr-1" },
  { path: "/inbox", name: "Inbox", component: InboxView, showInNav: true, icon:"icon-drawer icons mr-1" },
  { path: "/tasks", name: "Kanban", component: TaskView, showInNav: true, icon:"icon-notebook icons mr-1" },
  { path: "/search", name: "Search", component: SearchView, showInNav: true, icon:"icon-magnifier icons mr-1" },
  { path: "/forms", name: "Forms", component: FormsView, showInNav: true, icon:"icon-note icons mr-1" },
  { path: "/tables", name: "Tables", component: TablesView, showInNav: true, icon:"icon-grid icons mr-1" },
  { path: "/elements", name: "Elements", component: ElementsView, showInNav: true, icon:"icon-layers icons mr-1" },
  { path: "/cards", name: "Cards", component: CardsView, showInNav: true, icon:"icon-doc icons mr-1" },
  { path: "/artwork", name: "Artwork", component: Illustrations, showInNav: true, icon:"icon-photo icons mr-1" },
  { path: "/icons", name: "Icons", component: Icons, showInNav: true, icon:"icon-puzzle icons mr-1" },
  { path: "/typography", name: "Typography", component: Typography, showInNav: true, icon:"icon-eyeglass icons mr-1" },
  { path: "/timeline", name: "Timeline", component: Timeline },
  { path: "/gallery", name: "Timeline Gallery", component: TimelineGallery },
  { path: "/pricing", name: "Pricing", component: Pricing },
  { path: "/faq", name: "FAQ", component: Faq },
  { path: "/404", name: "Error 404", component: NotFound },
  { path: "/500", name: "Error 500", component: Error500 },
  { //otherwise 404
    path: '*',
    component: NotFound
  }
];

export default routes;
